import { render, staticRenderFns } from "./smartmedical.vue?vue&type=template&id=374c818f&scoped=true&"
import script from "./smartmedical.vue?vue&type=script&lang=js&"
export * from "./smartmedical.vue?vue&type=script&lang=js&"
import style0 from "./smartmedical.vue?vue&type=style&index=0&id=374c818f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374c818f",
  null
  
)

export default component.exports